/* Chaman — carrito lateral con el diseño nuevo */
(function () {
  if (window.__chamanCart) return;
  window.__chamanCart = true;
  var FREE = 10000; // envío gratis desde 100 € (céntimos)
  var css = `
.chc-ov{position:fixed;inset:0;background:rgba(10,46,34,.55);opacity:0;pointer-events:none;transition:opacity .25s;z-index:2147483000}
.chc-ov.is-open{opacity:1;pointer-events:auto}
.chc{position:fixed;top:0;right:0;height:100%;width:420px;max-width:100%;background:#FBF1E1;color:#2B1A12;z-index:2147483001;transform:translateX(100%);transition:transform .3s ease;display:flex;flex-direction:column;box-shadow:-20px 0 60px rgba(0,0,0,.3);font-family:Manrope,sans-serif}
.chc.is-open{transform:none}
.chc__head{background:#0E3B2C;color:#FBF1E1;padding:22px 24px;display:flex;align-items:center;justify-content:space-between}
.chc__head h3{margin:0;font-family:Fraunces,serif;font-size:26px;font-weight:600;color:#FBF1E1}
.chc__x{background:none;border:0;color:#FBF1E1;font-size:30px;line-height:1;cursor:pointer;padding:0 4px}
.chc__ship{padding:16px 24px;background:#E3EDD5;font-size:14px;font-weight:600;color:#0E3B2C}
.chc__bar{height:8px;border-radius:4px;background:#fff;margin-top:10px;overflow:hidden}
.chc__bar i{display:block;height:100%;background:#F29E4C;border-radius:4px;transition:width .3s}
.chc__items{flex:1;overflow:auto;padding:8px 24px}
.chc__it{display:flex;gap:14px;padding:16px 0;border-bottom:1px solid rgba(43,26,18,.12);align-items:center}
.chc__it img{width:72px;height:88px;object-fit:contain;background:#F6B93B;border-radius:14px;padding:6px}
.chc__it b{display:block;font-family:Fraunces,serif;font-size:18px;font-weight:600;margin-bottom:4px}
.chc__it small{color:#6B5446;font-size:13px}
.chc__q{display:flex;align-items:center;gap:10px;margin-top:10px}
.chc__q button{width:30px;height:30px;border-radius:50%;border:1.5px solid #0E3B2C;background:none;color:#0E3B2C;font-size:16px;cursor:pointer;line-height:1}
.chc__pr{margin-left:auto;font-weight:700;white-space:nowrap}
.chc__empty{text-align:center;padding:60px 10px;color:#6B5446}
.chc__foot{padding:20px 24px 26px;border-top:1px solid rgba(43,26,18,.12);background:#FBF1E1}
.chc__tot{font-family:Fraunces,serif;font-size:20px!important;display:flex;justify-content:space-between;font-size:18px;font-weight:700;margin-bottom:6px}
.chc__note{font-size:12px;color:#6B5446;margin:0 0 14px}
.chc__go{display:flex;align-items:center;justify-content:center;height:56px;border-radius:28px;background:#C8102E;color:#fff!important;font-weight:700;font-size:16px;text-decoration:none;border:0;width:100%;cursor:pointer;font-family:Manrope,sans-serif}
.chc__go:hover{background:#A30D25}
.chc__go[aria-disabled=true]{opacity:.4;pointer-events:none}
.chc__cont{display:block;text-align:center;margin-top:12px;color:#0E3B2C;font-weight:600;font-size:14px;background:none;border:0;width:100%;cursor:pointer}
.chc-busy{opacity:.6;pointer-events:none}
`;
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var ov = document.createElement('div'); ov.className = 'chc-ov';
  var d = document.createElement('aside'); d.className = 'chc'; d.setAttribute('role', 'dialog'); d.setAttribute('aria-label', 'Carrito');
  d.innerHTML = '<div class="chc__head"><h3>Tu carrito</h3><button class="chc__x" type="button" aria-label="Cerrar">&times;</button></div>' +
    '<div class="chc__ship"></div><div class="chc__items"></div>' +
    '<div class="chc__foot"><div class="chc__tot"><span>Subtotal</span><span class="chc__sub"></span></div>' +
    '<p class="chc__note">Impuestos incluidos. Envío calculado en el pago.</p>' +
    '<a class="chc__go" href="/checkout">Finalizar compra</a>' +
    '<button class="chc__cont" type="button">Seguir comprando</button></div>';
  document.documentElement.appendChild(ov); document.documentElement.appendChild(d);

  var eur = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  function m(c) { return eur.format(c / 100); }
  function esc(s) { var x = document.createElement('div'); x.textContent = s || ''; return x.innerHTML; }
  function open() { ov.classList.add('is-open'); d.classList.add('is-open'); }
  function close() { ov.classList.remove('is-open'); d.classList.remove('is-open'); }
  ov.addEventListener('click', close);
  d.querySelector('.chc__x').addEventListener('click', close);
  d.querySelector('.chc__cont').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function render(c) {
    var items = d.querySelector('.chc__items');
    if (!c.item_count) {
      items.innerHTML = '<div class="chc__empty">Tu carrito está vacío.<br>¡Pide tu Chaman!</div>';
    } else {
      items.innerHTML = c.items.map(function (it, i) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        var v = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        return '<div class="chc__it">' + (img ? '<img src="' + img + '" alt="">' : '') +
          '<div><b>' + esc(it.product_title) + '</b>' + v +
          '<div class="chc__q"><button type="button" data-l="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Quitar uno">&minus;</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-l="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Añadir uno">+</button></div></div>' +
          '<span class="chc__pr">' + m(it.final_line_price) + '</span></div>';
      }).join('');
    }
    var t = c.total_price, left = FREE - t;
    d.querySelector('.chc__ship').innerHTML = (left > 0
      ? 'Te faltan <b>' + m(left) + '</b> para el envío gratis'
      : '¡Tienes <b>envío gratis</b>!') +
      '<div class="chc__bar"><i style="width:' + Math.min(100, t / FREE * 100) + '%"></i></div>';
    d.querySelector('.chc__sub').textContent = m(t);
    d.querySelector('.chc__go').setAttribute('aria-disabled', c.item_count ? 'false' : 'true');
    document.querySelectorAll('.ch-cart').forEach(function (a) {
      a.childNodes.forEach(function (n) { if (n.nodeType === 3 && /\(\d+\)/.test(n.textContent)) n.textContent = n.textContent.replace(/\(\d+\)/, '(' + c.item_count + ')'); });
      a.querySelectorAll('span').forEach(function (s) { if (/^\s*\(\d+\)\s*$/.test(s.textContent)) s.textContent = '(' + c.item_count + ')'; });
    });
  }
  function load() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render); }

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-l]'); if (!b) return;
    d.classList.add('chc-busy');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.dataset.l, quantity: Math.max(0, +b.dataset.q) }) })
      .then(function (r) { return r.json(); }).then(render)
      .finally(function () { d.classList.remove('chc-busy'); });
  });

  function isAdd(f) { return f && f.tagName === 'FORM' && /\/cart\/add/.test(f.getAttribute('action') || ''); }
  function add(f) {
    var btn = f.querySelector('[type=submit]'); if (btn) btn.classList.add('chc-busy');
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return load(); })
      .then(open)
      .catch(function () { HTMLFormElement.prototype.submit.call(f); })
      .finally(function () { if (btn) btn.classList.remove('chc-busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button, input[type=submit]');
    if (!b || (b.type && b.type !== 'submit')) return;
    var f = b.form || b.closest('form');
    if (!isAdd(f)) return;
    e.preventDefault(); e.stopImmediatePropagation(); add(f);
  }, true);
  document.addEventListener('submit', function (e) {
    if (!isAdd(e.target)) return;
    e.preventDefault(); e.stopImmediatePropagation(); add(e.target);
  }, true);

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.ch-cart, a[href="/cart"]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); e.stopImmediatePropagation(); load().then(open);
  }, true);

  load();
})();
